export default __webpack_public_path__ + "static/media/travel-docs-fake.0b8da5ec.png";